import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';

// Components
import Loader from '../../utils/Loader';
import ShippingMethodItem from './ShippingMethodItem';

// CSS
import '../../../css/react-select.css';

// State
import { setActiveCheckoutSection } from '../../../store/actions/checkout';
import {
    getShippingPaymentOptions,
    setShippingPaymentOption,
} from '../../../store/actions/shippingPayment';

// Util
import {
    setCheckoutSectionActive as setCheckoutSectionActiveGA,
    setCheckoutSectionComplete as setCheckoutSectionCompleteGA,
} from '../../../utils/google-analytics';

class ShippingMethodSection extends Component {
    constructor(props) {
        super(props);

        this.state = {
            option: null,
        };
    }

    // ===================================
    //  LIFE CYCLE HOOKS
    // ===================================
    componentDidMount() {
        if (!!this.props.shipping.delivery_id) {
            // Set current section as complete
            setCheckoutSectionCompleteGA(4);

            // Set Order active
            setCheckoutSectionActiveGA(5);
            this.props.setActiveCheckoutSection('billing');
            return;
        }

        this.getOptions();
    }

    componentDidUpdate(prevProps) {
        // If the cart sub total has changed, go get the shipping methods again
        if (prevProps.cartSubTotal !== this.props.cartSubTotal) {
            this.getOptions();
        }
    }

    getOptions = () => {
        this.props.getShippingPaymentOptions().then((res) => {
            // console.log(res)
            // If nothing is returned, bail!  No options available
            if (!res) return;

            // If this is set, the user has already made a selection.
            let { shippingMethodSelected } = this.props;

            // Ensure the selected method is available as defined by it's "name".
            // If the prices are different than what is selected, at least it will be selected.
            if (!!shippingMethodSelected) {
                shippingMethodSelected = res.options.filter((option) => {
                    return shippingMethodSelected.name === option.name;
                });
            }

            // Set the state based on previous user selection, or the first option available
            this.setState({
                option:
                    !!shippingMethodSelected && shippingMethodSelected.length
                        ? shippingMethodSelected[0]
                        : res.options[0],
            });
        });
    };

    updateSelectedOption = (selection) => {
        this.setState({
            option: selection,
        });
    };

    handleSubmit = (event) => {
        event.preventDefault();

        setCheckoutSectionCompleteGA(4);
        setCheckoutSectionActiveGA(5);
        this.props.setActiveCheckoutSection('billing');

        this.props.setShippingPaymentOption(this.state.option).then(() => {
            // Set current section as complete
            setCheckoutSectionCompleteGA(4);

            // Set Order active
            setCheckoutSectionActiveGA(5);
            this.props.setActiveCheckoutSection('billing');
        });
    };

    render() {
        const {
            shippingOptionsLoading,
            shippingOptionsError,
            options,
            selectionLoading,
            selectionError,
        } = this.props;

        return (
            <div>
                <div className="delivery-heading">
                    <h2>Select your shipping method:</h2>
                </div>

                <div className="container">
                    {shippingOptionsLoading ? (
                        <Loader />
                    ) : shippingOptionsError ? (
                        <div className="error top-margin">
                            {shippingOptionsError.general}
                        </div>
                    ) : (
                        <React.Fragment>
                            <Select
                                classNamePrefix="react-select"
                                name={`option`}
                                placeholder="Choose One"
                                value={options.filter(
                                    ({ name }) =>
                                        !!this.state.option &&
                                        name === this.state.option.name
                                )}
                                isClearable={false}
                                isDisabled={selectionLoading}
                                onChange={this.updateSelectedOption}
                                options={options}
                                getOptionLabel={(option) => (
                                    <ShippingMethodItem option={option} />
                                )}
                                getOptionValue={({ name }) => name}
                            />

                            {!!selectionError && (
                                <div className="error top-margin">
                                    {selectionError.general}
                                </div>
                            )}

                            <div className="container review-buttons">
                                <button
                                    className={
                                        'btn' + (selectionLoading ? ' loading' : '')
                                    }
                                    disabled={selectionLoading}
                                    onClick={this.handleSubmit}
                                >
                                    <span>Select method</span>
                                </button>
                            </div>
                        </React.Fragment>
                    )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        shipping: state.checkout.shipping,
        cartSubTotal: !!state.cart.sub_total ? state.cart.sub_total : null,
        shippingMethodSelected:
            typeof state.cart.shipping_method === undefined
                ? null
                : state.cart.shipping_method,
        shippingOptionsLoading:
            typeof state.shippingPayment.isLoading === undefined
                ? 1
                : state.shippingPayment.isLoading,
        shippingOptionsError: !!state.shippingPayment.error
            ? state.shippingPayment.error
            : null,
        options: !!state.shippingPayment.options ? state.shippingPayment.options : [],
        selectionLoading: !!state.shippingPayment.selectionLoading
            ? state.shippingPayment.selectionLoading
            : 0,
        selectionError: !!state.shippingPayment.selectionError
            ? state.shippingPayment.selectionError
            : null,
    };
};

export default connect(
    mapStateToProps,
    {
        getShippingPaymentOptions,
        setShippingPaymentOption,
        setActiveCheckoutSection,
        setCheckoutSectionActiveGA,
    }
)(ShippingMethodSection);



// WEBPACK FOOTER //
// ./src/components/checkout/shipping-payment/ShippingMethodSection.js